import ReactDOM from 'react-dom';
import './theme/color.scss';
import './styles.scss';
import './antd.less';
import { App } from './app/App';

ReactDOM.render(<App />, document.getElementById('root'));
